<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/preface#preface">Preface</a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/intro#intro">Introduction: Your Past Can Work for You</a></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part01#part01" title="Link target outside of Sample">P<span class="small">ART</span> I: D<span class="small">ISCOVERING THE</span> P<span class="small">OWER OF</span> Y<span class="small">OUR</span> P<span class="small">AST</span></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample">Chapter 1: The Underused Past:<br/>The Price of Forgotten Yesterdays</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Chapter 2: Good and Bad News:<br/>Evoked and Compressed</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample">P<span class="small">ART</span> II: T<span class="small">APPING THE</span> P<span class="small">OWER OF</span> Y<span class="small">OUR</span> P<span class="small">AST</span></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3: Recall</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4: Reclaim</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Chapter 5: Recast</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample">P<span class="small">ART</span> III: C<span class="small">HANNELING THE</span> P<span class="small">OWER OF</span> Y<span class="small">OUR</span> P<span class="small">AST</span></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6: Answering the Big Question:<br/>When to Say Yes and No</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7: Using Suffering to Grow</span></p>
<p class="tocbackt"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/about#about" title="Link target outside of Sample">About the Author</span></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?db5c4852